<div>
  <div
    *ngIf="
      !selectedFacetValue &&
      (platformService?.platformType ===
        platformService?.platformEnum?.mobile ||
        !!this.facetValue)
    "
    class="filter-title"
  >
    <ion-icon name="chevron-back-outline" (click)="navigateBack()"></ion-icon>
    <ion-label>{{ label | titlecase }}{{ facetValueTotalCount }}</ion-label>
  </div>
  <div class="filter-content" *ngIf="!selectedFacetValue">
    <div class="filters-details" [formGroup]="formGroup">
      <div class="filter-input">
        <div class="filter-item">
          <ion-list>
            <ng-container *ngFor="let facetValue of facetValues">
              <ion-item
                *ngIf="facetValue?.childrenFacetValues?.length > 0"
                (click)="setSelectedFacetValue(facetValue)"
                detail
              >
                <ion-label class="item-content">
                  <span class="child-facet-value">
                    {{ facetValue.label | titlecase }}
                    <span class="count"> ({{ facetValue.count }}) </span>
                  </span>
                </ion-label>
              </ion-item>
              <ion-item
                *ngIf="
                  !facetValue?.childrenFacetValues ||
                  facetValue?.childrenFacetValues?.length === 0
                "
              >
                <div class="item-content">
                  <ion-checkbox mode="ios" [formControlName]="facetValue.value">
                    <span class="child-facet-value">
                      {{ facetValue.label | titlecase }}
                      <span class="count"> ({{ facetValue.count }}) </span>
                    </span>
                  </ion-checkbox>
                </div>
              </ion-item>
            </ng-container>
          </ion-list>
        </div>
      </div>
    </div>
  </div>
  <app-facet-value-list
    *ngIf="!!selectedFacetValue"
    [facetValue]="selectedFacetValue"
    [formGroup]="$any(formGroup.controls[selectedFacetValue.value])"
    (clearSelectedFacetValue)="setSelectedFacetValue(null)"
  >
  </app-facet-value-list>
</div>
